<div class="animated fadeIn collection">
    <div class="row">
        <div class="col-12 collection-header">
            <button class="btn btn-link" [routerLink]="['/plantingSite', site.id, 'area', siteArea.id]">
                <i class="icon-arrow-left"></i>
            </button>
            <h3 class="header-3">{{site.title}} : {{video.date | date: 'MM/yyyy'}}</h3>
        </div>
        <div class="col-12 collection-detail">
            <h5>{{video.title}}</h5>
            <p>{{video.description}}</p>
        </div>
        <div class="collection-info">
            <div class="collection-photos">
                <div #youTubePlayer class="video">
                    <youtube-player *ngIf="video | videoThumbnail" [videoId]="getYoutubeId()" suggestedQuality="highres" [height]="videoHeight" [width]="videoWidth">
                    </youtube-player>
                </div>
            </div>
            <div class="col-xs-12 collection-map">
                <!-- <button class="btn btn-dark" [routerLink]="['/plantingSite', site.id, collection.id, 'map', activePhoto.id]"><i class="icon-size-fullscreen"></i></button> -->
                <agm-map [style.height]="'100%'" [style.width]="'100%'" [disableDoubleClickZoom]="true" [zoom]="18"
                    [streetViewControl]="false" [mapTypeId]="mapTypeId" [maxZoom]="20" [mapTypeControl]='true'
                    [zoomControl]='true' [fitBounds]="true">
                    <agm-marker [latitude]="site.lat" [longitude]="site.lon"
                        [iconUrl]="site.availableTrees > 0 ? availableIcon : notAvailableIcon">
                    </agm-marker>
                    <agm-kml-layer [url]="siteArea.kmlUrl + '?date=' + nowDate" >
                    </agm-kml-layer>
                    <agm-polyline [strokeOpacity]="0.8" [strokeWeight]="2" [strokeColor]="'#07b57a'">
                        <agm-polyline-point *ngFor="let coordinate of allFlightPath" [latitude]="coordinate.latitude"
                            [longitude]="coordinate.longitude">
                        </agm-polyline-point>
                    </agm-polyline>
                    <agm-marker *ngFor="let areaCoordinate of siteArea.kmlAreaProperties" [latitude]="areaCoordinate.latitude" [longitude]="areaCoordinate.longitude" [iconUrl]="labelBar" [label]="{
                        color: 'white',
                        fontFamily: '',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        text: siteArea.year
                    }" [agmFitBounds]="true" [visible]="map.zoom >=17"></agm-marker>
                </agm-map>
            </div>
        </div>
    </div>
</div>
